import { useLingui } from '@lingui/react/macro';

export interface ValidationMessages {
  studentFirstName: { required: string };
  studentLastName: { required: string };
  studentDob: { required: string };
  studentStreetAddress: { required: string };
  studentCity: { required: string };
  studentRegion: { required: string };
  studentPostalCode: { required: string };
  studentCountry: { required: string };
  studentPhone: { required: string };
  studentEmail: { required: string; email: string; unique: string };
  guardian1FirstName: { required: string };
  guardian1LastName: { required: string };
  guardian1StreetAddress: { required: string };
  guardian1City: { required: string };
  guardian1Region: { required: string };
  guardian1PostalCode: { required: string };
  guardian1Country: { required: string };
  guardian1Phone: { required: string };
  guardian1Email: { required: string; email: string; unique: string };
  guardian2FirstName: { required: string };
  guardian2LastName: { required: string };
  guardian2StreetAddress: { required: string };
  guardian2City: { required: string };
  guardian2Region: { required: string };
  guardian2PostalCode: { required: string };
  guardian2Country: { required: string };
  guardian2Phone: { required: string };
  guardian2Email: { required: string; email: string; unique: string };
  studentAllergies: { required: string };
  studentMedicalTreatment: { required: string };
  studentDietaryRequirements: { required: string };
  studentLearningDifficulties: { required: string };
  studentAllergiesSpecifics: { required: string };
  studentMedicalTreatmentSpecifics: { required: string };
  studentDietaryRequirementsSpecifics: { required: string };
  studentLearningDifficultiesSpecifics: { required: string };
}

export const useValidationMessages = (): ValidationMessages => {
  const { t } = useLingui();

  return {
    studentFirstName: {
      required: t`Student first name is required`,
    },
    studentLastName: {
      required: t`Student last name is required`,
    },
    studentDob: {
      required: t`Student birthday is required`,
    },
    studentStreetAddress: {
      required: t`Street address is required`,
    },
    studentCity: {
      required: t`City is required`,
    },
    studentRegion: {
      required: t`State / Region / Province is required`,
    },
    studentPostalCode: {
      required: t`Postal / Zip code is required`,
    },
    studentCountry: {
      required: t`Country is required`,
    },
    studentPhone: {
      required: t`Student phone is required`,
    },
    studentEmail: {
      required: t`Student email is required`,
      email: t`Email address is invalid`,
      unique: t`Email addresses must be unique to each person`,
    },
    guardian1FirstName: {
      required: t`Parent / Guardian 1 first name is required`,
    },
    guardian1LastName: {
      required: t`Parent / Guardian 1 last name is required`,
    },
    guardian1StreetAddress: {
      required: t`Street address is required`,
    },
    guardian1City: {
      required: t`City is required`,
    },
    guardian1Region: {
      required: t`State / Region / Province is required`,
    },
    guardian1PostalCode: {
      required: t`Postal / Zip code is required`,
    },
    guardian1Country: {
      required: t`Country is required`,
    },
    guardian1Phone: {
      required: t`Parent / Guardian 1 phone is required`,
    },
    guardian1Email: {
      required: t`Parent / Guardian 1 email is required`,
      email: t`Email address is invalid`,
      unique: t`Email addresses must be unique to each person`,
    },
    guardian2FirstName: {
      required: t`Parent / Guardian 2 first name is required`,
    },
    guardian2LastName: {
      required: t`Parent / Guardian 2 last name is required`,
    },
    guardian2StreetAddress: {
      required: t`Street address is required`,
    },
    guardian2City: {
      required: t`City is required`,
    },
    guardian2Region: {
      required: t`State / Region / Province is required`,
    },
    guardian2PostalCode: {
      required: t`Postal / Zip code is required`,
    },
    guardian2Country: {
      required: t`Country is required`,
    },
    guardian2Phone: {
      required: t`Parent / Guardian 2 phone is required`,
    },
    guardian2Email: {
      required: t`Parent / Guardian 2 email is required`,
      email: t`Email address is invalid`,
      unique: t`Email addresses must be unique to each person`,
    },
    studentAllergies: {
      required: t`An answer to allergies is required`,
    },
    studentMedicalTreatment: {
      required: t`An answer to medical treatments is required`,
    },
    studentDietaryRequirements: {
      required: t`An answer to dietary requirements is required`,
    },
    studentLearningDifficulties: {
      required: t`An answer to learning difficulties is required`,
    },
    studentAllergiesSpecifics: {
      required: t`Specifics of allergy is required`,
    },
    studentMedicalTreatmentSpecifics: {
      required: t`Specifics of medical treatments is required`,
    },
    studentDietaryRequirementsSpecifics: {
      required: t`Specifics of dietary requirements is required`,
    },
    studentLearningDifficultiesSpecifics: {
      required: t`Specifics of learning difficulties is required`,
    },
  };
};
